const BASE_URL = "/integration";

export default [
  {
    path: `${BASE_URL}/chart-of-account`,
    name: "Chart of Account Integration",
    component: () => import("@/modules/coa_integration/view/ConfigPage.vue"),
  },
  {
    path: `${BASE_URL}/self-billed-invoice`,
    name: "Self Billed Invoice",
    component: () => import("@/pages/taxInterface/selfBilledInvoice.vue"),
  },
  {
    path: `${BASE_URL}/tax-integration-log`,
    name: "Tax Integration Log",
    component: () => import("@/pages/taxInterface/integrationLog.vue"),
  },
];
